import { i18n } from '@lingui/core';
import { getURLSearchParamsFromQuery } from '@schibsted-nmp/search-frontend-clients';
import { IconMap16 } from '@warp-ds/icons/react/map-16';
import { Button } from '@warp-ds/react';
import React from 'react';
import { useAppConfig } from '../../AppConfig';
import { useSearchParams } from '../../data/SearchParamsStore';

export function MapLink() {
    const { mapUrl } = useAppConfig();
    const { searchParams } = useSearchParams();

    const mapUrlWithParams = new URL(mapUrl);
    mapUrlWithParams.search =
        getURLSearchParamsFromQuery(searchParams).toString();

    return (
        <Button
            className="flex items-center space-x-8"
            href={mapUrlWithParams.href}
            utility
        >
            <IconMap16 />
            <span className="hidden sm:inline">
                {i18n.t({
                    id: 'results.link-to-map',
                    message: 'Show on map',
                })}
            </span>
        </Button>
    );
}
